export default __webpack_public_path__ + "static/media/web.07e9ec83.jpg";